export default Object.freeze({
	Core: 375,
	Office: 376,
	Essential: 378,
	Ecommerce: 377,
	CoreV380: 380,
	OfficeV381: 381,
	EcommerceV383: 383,
	PAYG: 382,
});
